// @ts-check
import AvailableSlotsPicker from './AvailableSlotsPicker';

export default AvailableSlotsPicker;
